import { Outlet } from "react-router";
import GridToolBar from "../../components/GridToolBar";
import { VideoGrid } from "../../components/DataGrid/VideoGrid";

export default function Video() {
  return (
    <main>
      <VideoGrid />
    </main>
  );
}
